// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"522":"fdd586f9","828":"47a33051"}[chunkId] + ".chunk.css";
};